export default __webpack_public_path__ + "e9df21795323973fdea3669b6f76e08a.svg";